<script>
import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  props: {
    completedPercent: {
      type: Number
    },
    label:{
        type:String
    }
  },
  data() {
    return {
      chartData: {
        datasets: [
          {
            borderWidth: 0,
            backgroundColor: ['#b9b9b9', '#e8e8e8'],
            data: []
          }
        ]
      },
      options: {
        tooltips: false,
        segmentShowStroke: false,
        cutoutPercentage: 80,
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  created() {
    this.chartData.datasets[0].data.push(
      this.completedPercent,
      100 - this.completedPercent
    );
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  beforeMount() {
    Chart.plugins.register({
      beforeDraw: function(chart) {
        var data = chart.data.datasets[0].data[0];
        var sum = data;
        var width = chart.chart.width,
          height = chart.chart.height,
          ctx = chart.chart.ctx;
        ctx.restore();
        //var fontSize = (height / 10).toFixed(2);
        //Bkup: ctx.font = 0.9 + "em Arial";
        ctx.font = 16 + "px Gotham Medium";
        ctx.fillStyle = "#555";
        ctx.textBaseline = "middle";
        var text = sum + "%",
          textX = Math.round((width - ctx.measureText(text).width) / 2),
          textY = height / 2;
        ctx.fillText(text, textX, textY);
        ctx.save();
      }
    });
  },
  watch:{
    completedPercent()
    {
        this.chartData.datasets[0].data=[];
        this.chartData.datasets[0].data.push(
          this.completedPercent,
          100 - this.completedPercent
        );
        this.renderChart(this.chartData, this.options);
    }
  } 
};
</script>
